module.exports = __webpack_public_path__ + "img/onboarding-icon-twitter.acffab89.svg";